module.exports = __webpack_public_path__ + "img/invoice-ch-female.528a26fd.png";